import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45parsing_45global from "/opt/buildhome/repo/middleware/routeParsing.global.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  route_45parsing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}